import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'codeProduitSuffix'
})
export class CodeProduitSuffixPipe implements PipeTransform {
  transform(codeProduit: string, isDateCourte: boolean): string {
    return isDateCourte ? `${codeProduit}` : codeProduit;
  }
}